import Observer from 'common/scripts/observer';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class CustomSelect {
    /* eslint-disable max-statements */
    constructor(options) {
        this.options = options;
        this.elem = Utils.isElement(options.elem) ? options.elem : document.querySelector(options.elem);

        if (!this.elem) {
            console.error(`Element with selector "${options.elem}" not found!`);

            return;
        }

        this.inputSelector = '.j-custom-select__input';
        this.contentSelector = '.j-custom-select__content';
        this.valueSelector = '.j-custom-select__value';
        this.checkSelector = '.j-custom-select__checkbox';
        this.groupCheckSelector = '.j-custom-select__group-checkbox';
        this.groupLabelSelector = '.j-custom-select__group-label';
        this.groupSelector = '.j-custom-select__group';
        this.closeSelector = '.j-custom-select__close';
        this.itemsWrapSelector = '.j-custom-select__items';
        this.itemClass = '.j-custom-select-item';
        this.singleClass = 'j-custom-select_single_select';
        this.openClass = 'is-open';
        this.checkedClass = 'is-checked';
        this.disableClass = 'is-disabled';

        this.isOpen = false;
        this.isSingleSelect = false;
        this.summaryPrefix = ['Выбран', 'Выбрано', 'Выбрано'];

        this._clickOutside = this._clickOutside.bind(this);
    }

    init() {
        if (!this.elem) {
            return;
        }

        this._toggleFix = this._toggleFix.bind(this);
        this._initElements();
        this._getDataset();

        if (this.elem.classList.contains(this.openClass)) {
            this.open();
        }

        if (this.elem.classList.contains(this.singleClass)) {
            this.isSingleSelect = true;
        }

        this._bindEvents();
        this._changeValue();
    }

    /**
     * Инит элементов
     * @private
     */
    _initElements() {
        this.input = this.elem.querySelector(this.inputSelector);
        this.content = this.elem.querySelector(this.contentSelector);
        this.value = this.elem.querySelector(this.valueSelector);
        this.closeButtons = Array.from(this.elem.querySelectorAll(this.closeSelector));
        this.checks = Array.from(this.elem.querySelectorAll(this.checkSelector));
        this.groupChecks = Array.from(this.elem.querySelectorAll(this.groupCheckSelector));
        this.groupLabels = Array.from(this.elem.querySelectorAll(this.groupLabelSelector));
        this.groups = Array.from(this.elem.querySelectorAll(this.groupSelector));
        this.itemsWrap = this.elem.querySelector(this.itemsWrapSelector);
        this.prevClass = null;
    }

    /**
     * Берет данные из data-атрибутов
     * @private
     */
    _getDataset() {
        const {placeholder, suffix, prefix, valueType} = this.elem.dataset;

        this.placeholder = placeholder;
        this.suffix = suffix;
        this.prefix = prefix;
        this.valueType = valueType;
    }

    /**
     * Вешает обработчики событий
     * @private
     */
    _bindEvents() {
        this.closeButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.close();
            });
        });

        this.input.addEventListener('click', () => {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        });

        // Чек опшенов
        this.checks.forEach((check) => {
            check.addEventListener('change', () => {
                if (this.isSingleSelect) {
                    this._setActiveClass(check);
                    this.hideAll();
                    this._showAdditional(check);
                    this._emptyChecks(check);
                    this._changeValue();
                    this.close();
                } else {
                    this._checkInsideGroup(check);
                    this._changeValue();
                }
            });
        });

        // Чек заголовков группы
        this.groupChecks.forEach((check) => {
            check.addEventListener('change', () => {
                this._checkGroup(check);
                this._changeValue();
            });
        });

        // Клик по псевдочеку группы
        this.groupLabels.forEach((label) => {
            label.addEventListener('click', () => {
                label.classList.toggle(this.checkedClass);
                this._checkGroup(label);
                this._changeValue();

                if (this.options.onGroupClick) {
                    this.options.onGroupClick();
                }
            });
        });
    }

    /**
     * Открыть выпадающий список
     */
    open() {
        document.addEventListener('click', this._clickOutside);
        this.isOpen = true;
        this.elem.classList.add(this.openClass);
        $(this.content)[Utils.isMobile() ? 'fadeIn' : 'slideDown'](300);
        this._fixBody();
    }

    /**
     * Закрыть выпадающий список
     */
    close() {
        const wasOpen = this.isOpen;

        document.removeEventListener('click', this._clickOutside);
        this.isOpen = false;
        $(this.content)[Utils.isMobile() ? 'fadeOut' : 'slideUp'](300);
        this.elem.classList.remove(this.openClass);
        this._unfixBody();

        if (wasOpen) {
            observer.publish('custom-select:close', this);
        }
    }

    _fixBody() {
        if (!Utils.isMobile()) {
            return;
        }

        Utils.bodyStatic();
        Utils.bodyFixed(this.itemsWrap);
        this._bindResize();
    }

    _unfixBody() {
        if (!Utils.isMobile()) {
            return;
        }

        Utils.bodyStatic();
        this._unbindResize();
    }

    /**
     * Вешает обработчики на резайз и изменение ориентации
     * @private
     */
    _bindResize() {
        window.addEventListener('resize', this._toggleFix);
        window.addEventListener('orientationchange', this._toggleFix);
    }

    /**
     * Снимает ресайз-обработчики
     * @private
     */
    _unbindResize() {
        window.removeEventListener('resize', this._toggleFix);
        window.removeEventListener('orientationchange', this._toggleFix);
    }

    _toggleFix() {
        if (!Utils.isMobile() && this.isOpen) {
            this._unfixBody();
        }
    }

    /**
     * Ловит клик снаружи элемента
     * @param {object} event - объект события клика
     * @private
     */
    _clickOutside(event) {
        if (!event && !event.target) {
            return;
        }

        if (!Utils.closest(event.target, this.elem)) {
            this.close();
        }
    }

    /**
     * Клик по чекбоксу группы
     * @param {Element} groupCheck - элемент чекбокса
     * @private
     */
    _checkGroup(groupCheck) {
        const checked = groupCheck.checked ||
            (groupCheck.classList.contains(this.checkedClass) && !groupCheck.classList.contains(this.disableClass));
        const group = groupCheck.closest(this.groupSelector);

        this.checks.forEach((check) => {
            if (check.closest(this.groupSelector) === group) {
                check.checked = checked;
            }
        });
    }

    /**
     * Если ли у группы внутри что-то чекнутое
     * @param {Element} group - группа
     * @return {boolean} - true - внутри ничего не отмечено
     * @private
     */
    _isGroupEmpty(group) {
        return !Array.from(group.querySelectorAll(`${this.checkSelector}:checked`)).length;
    }


    /**
     * Оставляет чекнутым только тот чекбокс, который выбираем
     * @param {Element} check - элемент чекбокса
     * @private
     */
    _emptyChecks(check) {
        const checkedArr = Array.from(this.elem.querySelectorAll(`${this.checkSelector}:checked`));

        if (checkedArr.length > 1) {
            checkedArr.filter((item) => {
                // eslint-disable-next-line no-return-assign
                return item.checked = item === check;
            });
        }
    }

    /**
     * Обрабатывает группу вложенного чекбокса
     * @param {Element} check - элемент чекбокса
     * @private
     */
    _checkInsideGroup(check) {
        const group = check.closest(this.groupSelector);

        if (!group) {
            return;
        }

        const isGroupChecked = !this._isGroupEmpty(group);
        const label = group.querySelector(this.groupLabelSelector);

        if (label) {
            label.classList.toggle(this.checkedClass, isGroupChecked);

            return;
        }

        group.querySelector(this.groupCheckSelector).checked = isGroupChecked;
    }

    /**
     * Обновляет лейблы групп в зависимости от того, что происходит с чекбоксами у них внутри
     * @param {boolean} reset - true - сбросить все
     * @private
     */
    _updateGroups(reset) {
        this.groups.forEach((group) => {
            const groupLabel = group.querySelector(this.groupLabelSelector);

            if (!groupLabel) {
                return;
            }

            groupLabel.classList.remove(this.disableClass);

            if (reset) {
                groupLabel.classList.remove(this.checkedClass);

                return;
            }


            if (!this._isGroupEmpty(group)) {
                groupLabel.classList.add(this.checkedClass);

                return;
            }

            const len = Array.from(group.querySelectorAll(this.checkSelector)).length;
            const disabledLen = Array.from(group.querySelectorAll(`${this.checkSelector}:disabled`)).length;

            if (len === disabledLen) {
                groupLabel.classList.add(this.disableClass);
                groupLabel.classList.remove(this.checkedClass);
            }
        });
    }

    /**
     * Выводит список выбранного
     * @private
     */
    _changeValue() {
        const text = this.valueType === 'summary' ? this._getSummary() : this._collectText();

        this._insertTextValue(text);
    }

    /**
     * Возвращает строку-список выбранного в формате "Выбрано Х элементов"
     * НЕ ДОРАБОТАНО ДЛЯ ГРУПП ЧЕКБОКСОВ !!!
     * @return {string|*} - итоговая строка
     * @private
     */
    _getSummary() {
        const len = Array.from(this.elem.querySelectorAll(`${this.checkSelector}:checked`)).length;

        if (!len) {
            return this.placeholder;
        }

        const suffix = this.suffix ? Utils.pluralWord(len, this.suffix.split('|')) : '';

        return `${Utils.pluralWord(len, this.summaryPrefix)} ${len} ${suffix}`;
    }

    /**
     * Собирает список выбранного из названий (через запятую)
     * @return {string|*} - итоговая строка
     * @private
     */
    _collectText() {
        let finalText = '';

        if (this.groups.length) {
            finalText = this._collectGroupText();
        } else {
            for (let i = 0; i < this.checks.length; i++) {
                const check = this.checks[i];

                if (check.checked && check.value === 'reset') {
                    finalText = '';

                    return this.placeholder;
                }

                finalText = this._getItemsText(check, finalText);
            }
        }

        finalText = finalText.substr(2);

        if (!finalText) {
            return this.placeholder;
        }

        return `${this.prefix ? `${this.prefix} ` : ``}${finalText}`;
    }

    /**
     * Собирает список выбранного по группе
     * @return {string} - итоговая строка
     * @private
     */
    _collectGroupText() {
        let finalText = '';

        this.groups.forEach((group) => {
            const elem = group.querySelector(this.groupLabelSelector) || group.querySelector(this.groupCheckSelector);

            if (!elem.classList.contains(this.checkedClass) && !elem.checked) {
                return;
            }

            const checkedList = Array.from(group.querySelectorAll(`${this.checkSelector}:checked`));
            const targetList = checkedList.length > 0 ?
                checkedList :
                Array.from(group.querySelectorAll(this.checkSelector));

            targetList.forEach((check) => {
                finalText = this._getItemsText(check, finalText, checkedList.length === 0);
            });
        });

        return finalText;
    }

    /**
     * Получает текст чекбокса для вывода в cтроку результатов
     * @param {Element} item - элемент чекбокса
     * @param {string} str - строка, к которой нужно приклеить текст чекбокса
     * @param {boolean} forceGet - true - учитывать чекбокс даже если он не чекнут
     * @return {string|*} - итоговая строка
     * @private
     */
    _getItemsText(item, str, forceGet = false) {
        if (!item.checked && !forceGet) {
            return str;
        }

        const dataText = item.dataset.text;
        let itemText = `, ${dataText}`;

        if (!this.suffix) {
            return str + itemText;
        }

        let finalText = str;

        // Первый символ отмеченного - цифра
        // Подходит для комнат/этажей
        if (!isNaN(Number(dataText.slice(0, 1)))) {
            finalText = str.endsWith(this.suffix) ? str.slice(0, str.length - this.suffix.length) : str;
            itemText = itemText + this.suffix;
        }

        return finalText + itemText;
    }

    /**
     * Подставляет текстовое значение в инпут с результатами выбора
     * @param {string} text - текст, который нужно вставить
     * @private
     */
    _insertTextValue(text) {
        Utils.clearHtml(this.value);
        Utils.insetContent(this.value, text);
    }

    /**
     * Устанавливаем активный класс выбранному пункту и отмечаем текущий инпут заполненым
     * @param {object} item - выбранный элемент
     */
    _setActiveClass(item) {
        const allParents = Array.from(this.itemsWrap.querySelectorAll(this.itemClass));
        const inputValue = this.input.innerText;
        const itemValue = item.dataset.text;

        allParents.forEach((element) => {
            if (element.classList.contains('is-active')) {
                element.classList.remove('is-active');
            }
        });

        if (inputValue !== itemValue) {
            item.closest(this.itemClass).classList.add('is-active');

            this.input.classList.add('is-selected');
        }

        if (inputValue === itemValue) {
            this.input.classList.remove('is-selected');
        }
    }

    hideAll() {
        observer.publish('custom-select-hide-all', this.checks);
    }

    _showAdditional(item) {
        observer.publish('custom-select-changed', item);
    }

    /**
     * Возвращает список чекбоксов в формате объекта
     * @return {{checked: boolean, disabled: boolean, value: *}[]} - чекнут ли, задисейблен ли, значение
     */
    getOptions() {
        return this.checks.map((check) => {
            return {
                value   : check.value,
                checked : Boolean(check.checked),
                disabled: Boolean(check.disabled)
            };
        });
    }

    /**
     * Возвращает список неотмеченных чекбоксов в выбранных группах
     * @return {object} data - объект с чекбоксами в формате name: value
     */
    getGroupOptions() {
        const data = {};

        this.groups.forEach((group) => {
            const groupLabel = group.querySelector(`${this.groupLabelSelector}.${this.checkedClass}`);

            if (this._isGroupEmpty(group) && groupLabel) {
                Array.from(group.querySelectorAll(`${this.checkSelector}:not(:disabled)`)).forEach((check) => {
                    const name = check.getAttribute('name');
                    const value = check.getAttribute('value');

                    if (name in data) {
                        if (data[name] instanceof Array) {
                            data[name].push(value);
                        } else {
                            data[name] = [data[name], value];
                        }
                    } else {
                        data[name] = value;
                    }
                });
            }
        });

        return data;
    }

    /**
     * Обновляет селект снаружи
     * @param {boolean} reset - true - полный сброс
     */
    update(reset = false) {
        this._updateGroups(reset);
        this._changeValue();
    }
}

export default CustomSelect;
